// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5006":"00a92902","6040":"00a92902","6751":"100065f3"}[chunkId] + ".chunk.css";
};